export default __webpack_public_path__ + "static/media/paytm.b6b2a68f.svg";